<template>
  <div class="page-box log-page">
    <el-form
      :inline="true"
      @submit.native.prevent
    >
      <el-form-item>
        <el-select
          v-model="query.form.type"
          clearable
          placeholder="选择类型"
          style="width: 200px;"
          @change="handleFilter"
        >
          <el-option
            v-for="item in logTypes"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <!-- <el-form-item>
        <el-input
          v-model="query.form.main_id"
          clearable
          placeholder="ID"
          @keyup.enter.native="handleFilter"
        />
      </el-form-item> -->
      <el-form-item>
        <el-input
          v-model="query.form.route_name"
          clearable
          placeholder="操作名称"
          @keyup.enter.native="handleFilter"
        />
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="query.form.username"
          clearable
          placeholder="用户名称"
          @keyup.enter.native="handleFilter"
        />
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="query._date"
          style="width: 280px;"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="handleFilter"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          :loading="table.loading"
          @click="handleFilter"
        >
          搜索
        </el-button>
      </el-form-item>
    </el-form>

    <div class="query-data">
      <el-table
        v-loading="table.loading"
        :data="table.list"
        style="width: 100%"
        :header-row-style="() => 'color: #303133'"
        :header-cell-style="() => 'background-color: rgba(250,250,250,1)'"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <log-detail :id="props.row.id" />
          </template>
        </el-table-column>
        <el-table-column
          prop="create_at"
          label="操作时间"
          :min-width="170"
        />
        <el-table-column
          prop="id"
          label="操作编号"
          :min-width="90"
        />
        <el-table-column
          label="操作人"
          :min-width="120"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.user_id }} - {{ scope.row.username }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="route_name"
          label="操作类型"
          :min-width="120"
        />
        <el-table-column
          label="请求"
          :min-width="200"
        >
          <template slot-scope="scope">
            <div class="scope-item"><div class="i-label">请求ID:</div><div class="i-value">{{ scope.row.http_request_id }}</div></div>
            <div class="scope-item"><div class="i-label">请求路由:</div><div class="i-value">{{ scope.row.route }}</div></div>
            <div class="scope-item">
              <div class="i-label">请求参数:</div><div class="i-value">
                <span
                  class="i-btn"
                  @click="handleViewJson(scope.row.params)"
                >
                  查看详细
                </span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="ip"
          label="ip"
          :min-width="110"
        />
      </el-table>
    </div>

    <div class="query-pager">
      <el-pagination
        :current-page.sync="query.form.page"
        :page-sizes="[20, 30, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="table.total"
        style="margin-top: 24px; float: right"
        @size-change="handlePageSizeChange"
        @current-change="handleQueryPage"
      />
    </div>

    <json-drawer 
      :visible.sync="detailDrawer.visible"
      :json="detailDrawer.data"
    />
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import JsonDrawer from '@/components/JsonDrawer';
import Detail from './components/Detail';
const LogType = [
  {
    id: 1001,
    name: '产品列表',
  },
];
const req = new Request();

export default {
  name: 'LogList',
  components: {
    'json-drawer': JsonDrawer,
    'log-detail': Detail,
  },
  data() {
    return {
      logTypes: Object.values(LogType),
      query: {
        _date: [],
        form: {
          page: 1,
          page_size: 20,
          type: '',
          main_id: '',
          route_name: '',
          username: '',
          start_date: '',
          end_date: '',
        },
      },
      table: {
        loading: false,
        list: [],
        total: 0,
      },
      detailDrawer: {
        visible: false,
        data: '',
      },
    };
  },
  created() {
    const { type, id } = this.$route.query;
    this.query.form.main_id = !(id === undefined || id === '')
      ? Number(id)
      : '';
    this.query.form.type = type ? Number(type) : '';

    this._getList();
  },
  methods: {
    async _getList() {
      this.table.loading = true;
      const _date = this.query._date || [];
      const params = {
        ...this.query.form,
        start_date: _date[0] || '',
        end_date: _date[1] || '',
      };
      const res = await req.send(req.Apis.common.getLogList, params).fin(() => {
        this.table.loading = false;
      });
      let list = (res.data || {}).list || [];
      this.table.list = list;
      this.table.total = (res.data || {}).total || 0;
    },

    handleFilter() {
      this.query.form.page = 1;
      this._getList();
    },

    handlePageSizeChange(pageSize) {
      this.query.form.page_size = Number(pageSize);
      this._getList();
    },

    handleQueryPage(page) {
      this.query.form.page = Number(page);
      this._getList();
    },

    handleViewJson(data = '{}') {
      this.detailDrawer.data = parseConf(data);
      this.detailDrawer.visible = true;
    },
  },
};

// parseConfig
function parseConf(conf = '{}') {
  try {
    return JSON.parse(conf);
  } catch (e) {
    return {};
  }
}
</script>
<style lang="less" scoped>
.page-box.log-page {
  .query-pager {
    position: relative;
    overflow: hidden;
    padding-bottom: 16px;
  }
  .scope-item {
    display: flex;
    font-size: 12px;
    line-height: 20px;
    align-items: center;
    .i-label {
      width: 66px;
      color: #888;
    }
    .i-value {
      flex: 1;
      color: #444;
    }
    .i-btn {
      cursor: pointer;
      color: #409eff;
    }
  }
}
</style>
